import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CubiqueSupportComponent } from './cubique/support/cubique-support.component';
import { CubiquePrivacyComponent } from './cubique/privacy/cubique-privacy.component';
import { HeaderComponent } from './navigation/header/header.component';
import { CubiqueComponent } from './cubique/cubique.component';
import { MirinVerifyComponent } from './mirin-verify/mirin-verify.component';
import { MirinVerifyPrivacyComponent } from './mirin-verify/privacy/mirin-verify-privacy.component';
import { MirinVerifySupportComponent } from './mirin-verify/support/mirin-verify-support.component';

@NgModule({
  declarations: [
    AppComponent,
    CubiqueSupportComponent,
    CubiquePrivacyComponent,
    HeaderComponent,
    CubiqueComponent,
    MirinVerifyComponent,
    MirinVerifyPrivacyComponent,
    MirinVerifySupportComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
